<template>
    <img v-if="offering.imageUrl" :src="offering.imageUrl" class="imageView" alt="" />
</template>

<script>
import Offering from '../../js/dto/offering/Offering.js';

export default {
    props: {
        offering: {
            type: Offering,
            required: true,
        },
    },
}
</script>

<style scoped lang="scss">
.imageView {
    float: right;
}
</style>
